// Finds the index of an item in an array by matching a target value.
// Used to select items in lists (guidelines, gallery) based on URL contentPath.
//
// targetValue: The value to search for. Pass undefined when no specific item is requested
//              (e.g., no contentPath in URL) - this will fall back to the first item.
// getValue: Extractor function to get the comparable value from each item.
//
// returns null if items array is empty (nothing to select),
//         the matching index if found,
//         or 0 (first item) as fallback when targetValue is undefined or not found.
export const findIndexBy = <T>(
	items: T[],
	targetValue: string | undefined,
	getValue: (item: T) => string | undefined
): number | null => {
	if (items.length === 0) {
		return null;
	}

	if (targetValue !== undefined) {
		const index = items.findIndex((item) => getValue(item) === targetValue);
		if (index >= 0) {
			return index;
		}
	}

	// Fallback to first item
	return 0;
};
